module.exports = __webpack_public_path__ + "static/img/client32_img.7134916.png";